import { h, Fragment } from "preact";
import sanitizeOptionValue from "../../helpers/sanitizeOptionValue";
import { AccordionMinus, AccordionPlus } from "../../helpers/icons";

export default function ProductOptionSummary({
  optionName,
  selectedOptionValue,
  optionValuesCount,
}) {
  const countMessage =
    optionValuesCount === 1
      ? window.localeStrings.product.options_count.one
      : window.localeStrings.product.options_count.other.replace(
          "[count]",
          optionValuesCount,
        );
  return (
    <summary className="product-options__option-summary">
      <div className="product-options__option-summary-content">
        <div className="product-options__name">{optionName}</div>
        <div className="product-options__selected-value">
          {sanitizeOptionValue(selectedOptionValue)}
        </div>
      </div>
      <div className="product-options__option-summary-count">
        {countMessage}
      </div>
      <div className="product-options__option-summary-icon-wrapper">
        <AccordionPlus className="product-options__option-summary-icon product-options__option-summary-icon--open" />
        <AccordionMinus className="product-options__option-summary-icon product-options__option-summary-icon--close" />
      </div>
    </summary>
  );
}
